import { render, staticRenderFns } from "./NewColumna.vue?vue&type=template&id=18b06696"
import script from "./NewColumna.vue?vue&type=script&lang=js"
export * from "./NewColumna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports